<template>
    <app-content-admin>
        <template slot="header">Template</template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="primary"
                to="/template/add_template"
            >
                + Add Template
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Template Id</th>
                            <th scope="col">Project Id</th>
                            <th scope="col">Title</th>
                            <th scope="col">Description</th>
                            <th scope="col">Action</th>
                            <th scope="col">Notification</th>
                        </thead>
                        <tbody>
                            <tr
                                class="text-center"
                                v-for="row in rows"
                                :key="row.id_template"
                            >
                                <td :data-label="$t('template_id')">
                                    {{ row.id_template }}
                                </td>
                                <td :data-label="$t('project_id')">
                                    {{ row.id_project }}
                                </td>
                                <td
                                    :data-label="$t('title')"
                                    class="text-truncate"
                                >
                                    {{ row.template_title }}
                                </td>
                                <td :data-label="$t('description')">
                                    {{ row.template_description }}
                                </td>
                                <td :data-label="$t('action')">
                                    <v-menu
                                        :close-on-content-click="true"
                                        :nudge-width="200"
                                        :open-on-click="true"
                                        offset-y
                                        offset-x
                                        left
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="primary"
                                                text
                                                small
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                @click="
                                                    editTemplate(
                                                        row.id_template
                                                    )
                                                "
                                            >
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>
                                            <!-- <v-list-item @click="deleteTemplate(row.id_template)">
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item> -->
                                        </v-list>
                                    </v-menu>
                                </td>
                                <td>
                                    <v-btn
                                        color="primary"
                                        @click="PopupNotification(row.id_template)"
                                        v-if="row.template_status == 0"
                                    >
                                        <v-icon
                                            small
                                            color="white"
                                            style="margin-right: 5px"
                                            >mdi-bell</v-icon
                                        >
                                        Push
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        disabled
                                        v-else-if="row.template_status == 1"
                                    >
                                        Sending
                                    </v-btn>
                                    <v-btn
                                        color="secondary"
                                        v-else-if="row.template_status == 2"
                                    >
                                        Sent
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <v-layout justify-center>
                        <v-flex xs8>
                            <div class="text-xs-center" v-if="pages > 0">
                                <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
                            </div>
                        </v-flex>
                    </v-layout> -->
                    <div class="text-center">
                        <v-dialog v-model="dialog" width="auto">
                            <v-card>
                                <v-card-text
                                    style="font-size: 20px; padding: 30px"
                                >
                                    Are you sure you want to push notification
                                    for this template?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        variant="text"
                                        @click="
                                            PushNotification()
                                        "
                                    >
                                        Yes
                                    </v-btn>
                                    <v-btn
                                        color="green-darken-1"
                                        variant="text"
                                        @click="dialog = false"
                                    >
                                        No
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";
import router from "../../router";

export default {
    mixins: [vForm],

    data() {
        return {
            rows: [],
            pages: 0,
            page: 1,
            form: {
                page: 1,
                offset: 10,
            },
            dialog: false,
            get_id_template:0
        };
    },

    components: { ActiveLabel },

    created() {
        this.search();
    },

    methods: {
        async search(offset = 10, page = 1) {
            this.form.offset = offset;
            this.form.page = page;
            let loader = this.$loading.show();

            try {
                let token = store.getters["auth/token"];
                let res = await axios.get(
                    `/api/cloud/get_firebase_template_list?token=${token}`
                );
                if (res.data.status == "success") {
                    this.rows = res.data.data.result;
                    console.log(this.rows);
                }
            } catch (e) {
                this.$toastr.e(e.message);
            } finally {
                loader.hide();
            }
        },

        onListChange(page) {
            this.search(10, page);
        },

        async PushNoti(template_id, project_id) {
            const deviceToken =
                "co70Br5Mgk9bseJXnTNdDY:APA91bHl_CXn-OHPAioemQkUpsTNTVUpfqdOex1eyCLnh2h9eM7B6JCC3r2RpucPBMJ7wOStipGe_fCSAECQUi5XuM9BqpMQxPdrfQGwGfWcYLZvP2VyPkDGwCNG2gxs8kHNivae1r-l";
            let loader = this.$loading.show();

            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/send_notification?token=${token}`,
                    {
                        deviceToken: deviceToken,
                        id_template: template_id,
                        id_project: project_id,
                    }
                );
                if (res.data) {
                    this.$toastr.s("Notification Pushed Successful");
                }
            } catch (e) {
                console.log(e);
                this.$toastr.e(e.message);
            } finally {
                loader.hide();
            }
        },

        editTemplate(id) {
            this.$router.push({ path: "template/edit_template/" + id });
        },

        async deleteTemplate(id) {
            let loader = this.$loading.show();

            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/delete_firebase_template?token=${token}`,
                    { id_template: id }
                );
                if (res.data) {
                    this.$toastr.s("Delete successfully");
                }
            } catch (e) {
                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.search();
            }
        },

        PopupNotification(id) {
            this.dialog = true;
            this.get_id_template = id
        },

        async PushNotification() {
            let loader = this.$loading.show();

            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/update_firebase_template_status?token=${token}`,
                    { id_template: this.get_id_template }
                );
                if (res.data) {
                    this.$toastr.s("Notification Push");
                }
            } catch (e) {
                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.search();
            }
        },
    },
};
</script>
